document.addEventListener('DOMContentLoaded', function() {
  // Swiper for product youtube/image box
  const productSwiper = document.querySelector('.product-youtube_image-box');
  if (productSwiper && typeof Swiper !== 'undefined') {
    new Swiper('.product-youtube_image-box', {
      slidesPerView: 2,
      spaceBetween: 20,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 10,
        },
        500: {
          slidesPerView: 2,
          spaceBetween: 10,
        }
      }
    });
  }
});